import React from "react";
import {
  Container,
  Grid,
  makeStyles,
  Typography,
  Box,
} from "@material-ui/core";
import Founder from "./founder.png";
import Rectangle from "./rectangle.png";
import data from "./Data";
import InfoTable from "./InfoTable";
import Map from "./Map";
import FourthBox from "./FourthBox";
import LastTable from "./LastTable";
import BlurBoxBackgroundContainer from "../../component/BlurBoxBackgroundContainer";
const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: "rgba(2, 50, 4, 0.6)",
    height: "auto",
    paddingTop: "50px",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "8px",
    },
  },
  row: {
    // backgroundColor: "rgba(50,69,20,0.8)",

    height: "auto",
  },
  rowa: {
    height: "auto",
  },
  container: {
    marginTop: "-210px",
    marginBottom: "40px",
    paddingLeft: "40px",
    paddingRight: "40px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "-120px",
      paddingLeft: "10px",
      paddingRight: "10px",
    },
    height: "100%",
  },
  title: {
    paddingBottom: "40px",
  },
  timeline: {
    height: "100%",
    width: "100%",
  },
  box: {
    width: "auto",
    height: "auto",
    minHeight: "1px",
    // width: "100%",
    // height: "460px",
    backgroundColor: theme.palette.secondary.main,
    padding: "0 26px",
    [theme.breakpoints.down("sm")]: {
      // height: "auto",
      padding: "0 0px",
      paddingTop: "18px",
    },
    paddingTop: "20px",
    marginBottom: "30px",
  },
  founderBox: {
    width: "auto",
    height: "auto",
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {},
    [theme.breakpoints.down("sm")]: {
      // height: "auto",
      flexDirection: "column",
    },
  },
  secondaryBox: {
    width: "100%",
    height: "auto",
    backgroundColor: theme.palette.secondary.main,
    padding: "0 26px",
    paddingTop: "20px",
    marginBottom: "40px",
    [theme.breakpoints.down("sm")]: {
      // height: "auto",
      padding: "0 15px",
      paddingTop: "18px",
    },
  },
  thirdBox: {
    width: "100vw",
    height: "400px",

    padding: "0 26px",
    // paddingTop: "20px",
    marginBottom: "40px",
    [theme.breakpoints.between("lm", "lm")]: {
      // height: "auto",
      height: "300px",
    },
    [theme.breakpoints.between("md", "md")]: {
      // height: "auto",
      height: "300px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "450px",
    },
  },

  thirdBox_text: {
    paddingTop: "20px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "150px",
      // backgroundImage: `url(${MobileBox}) , linearGradient(#923,#920)`,

      // backgroundPosition: "center center",
    },
  },
  thirdBox_p: {
    width: "45%",
    [theme.breakpoints.between("lm", "lm")]: {
      fontSize: "12px",
      letterSpacing: ".64px",
      width: "75%",
    },

    [theme.breakpoints.between("md", "md")]: {
      fontSize: "12px",
      letterSpacing: ".64px",
      width: "65%",
    },

    [theme.breakpoints.down("sm")]: {
      width: "auto",
      fontSize: "14px",
    },
    [theme.breakpoints.down("s")]: {
      width: "auto",
      fontSize: "12px",
    },
    // [theme.breakpoints.down("md")]: {
    //   width: "auto",
    // },
  },
  firstbgBoxCover: {
    [theme.breakpoints.down("sm")]: {
      backgroundColor: "rgba(255,255,255,0.6)",
      width: "100vw",
      height: "200px",
      zIndex: "20",
      marginTop: "200px",
    },
  },

  paragraph: {
    display: "flex",
    flexDirection: "column",
    // padding: "40px",
  },
  imageBox: {},
  imageFounder: {
    maxWidth: "100%",
    maxHeight: "368px",
    width: "auto",
    height: "auto",
    // marginTop: "20px",
    // verticalAlign: "middle",
    margin: "auto",
    [theme.breakpoints.between("lm", "lm")]: {
      width: "207px",
      height: "auto",
    },
    [theme.breakpoints.between("md", "md")]: {
      width: "156px",
      height: "auto",
    },
    [theme.breakpoints.down("sm")]: {
      width: "200px",
      marginBottom: "20px",
    },
  },
  content: {
    // height: "auto",

    height: "0%",
    padding: " 0 15px",
  },
  founderBody: {
    [theme.breakpoints.between("lm", "lm")]: {
      fontSize: "0.75rem",
    },
    [theme.breakpoints.between("md", "md")]: {
      fontSize: "0.625rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
    },
  },
  timeLineBox: {
    paddingTop: "20px",
    textAlign: "center",
    letterSpacing: ".86px",
    height: "100%",
    backgroundColor: "rgb(232, 232, 232)",
    paddingLeft: "10px",
    paddingRight: "10px",
    zIndex: 50,
    [theme.breakpoints.between("lm", "lm")]: {
      paddingLeft: "25px",
      paddingRight: "25px",
    },
    [theme.breakpoints.between("md", "md")]: {
      paddingLeft: "15px",
      paddingRight: "15px",
    },
  },
  timeLineText: {
    [theme.breakpoints.between("lm", "lm")]: {
      fontSize: ".6875rem",
    },
    [theme.breakpoints.between("md", "md")]: {
      fontSize: ".5rem",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      fontSize: "1.125rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem",
    },
  },
  circle: {
    height: "9px",
    width: "9px",
    backgroundColor: "green",
    borderRadius: "50%",
    display: "block",
    margin: "auto",
  },
  line: {
    display: "block",
  },
  map: {
    width: "100%",
    marginBottom: "30px",
  },
  secondBg: {
    backgroundImage: `url(${Map})`,
    position: "relative",
    height: "400px",
    width: "auto",

    backgroundSize: "cover",
  },

  subtitleHeader: {
    [theme.breakpoints.down("sm")]: {
      fontSize: ".75rem",
      letterSpacing: ".60px",
    },
  },
}));
export default function About() {
  const classes = useStyles();

  return (
    <BlurBoxBackgroundContainer background="aboutPage--background">
      <Container className={classes.container} maxWidth="lg">
        <Typography color="primary" variant="h1" className={classes.title}>
          経営理念
        </Typography>
        <Typography variant="body1" className={classes.subtitleHeader}>
          食をつうじ、人々の健康と幸せに貢献します。
        </Typography>
        <Grid container className={classes.root} spacing={4}>
          <Grid item container className={classes.row} md={9} xs={12}>
            <MainBox />
            <InfoBox />
            <BackgroundBox />
            <FourthBox />
            <LastTable />
          </Grid>
          <Grid item className={classes.rowa} xs={12} md={3}>
            <TimeLine />
          </Grid>
        </Grid>{" "}
      </Container>{" "}
    </BlurBoxBackgroundContainer>
  );
}

const MainBox = () => {
  const classes = useStyles();
  return (
    <Box className={classes.box}>
      <Box className={classes.founderBox}>
        <div className={classes.content}>
          <Typography color="primary" variant="h2" gutterBottom>
            会長からのメッセージ
          </Typography>
          <Typography
            variant="body1"
            className={classes.founderBody}
            paragraph={true}
            gutterBottom
          >
            私たちはお客様に美味しい料理を作っていただき、そして食べることは健康の源であり家族の団欒や仲間との楽しいひと時の食卓の笑顔には人々の喜びや小さな幸せがあります。
          </Typography>
          <Typography
            variant="body1"
            className={classes.founderBody}
            paragraph={true}
            gutterBottom
          >
            陰ながら人々の幸せに貢献できる仕事に私たちは生きがいと喜びを感じています。
          </Typography>
          <Typography
            variant="body1"
            className={classes.founderBody}
            paragraph={true}
            gutterBottom
          >
            美味しい料理は素材から・・・{" "}
          </Typography>
          <Typography
            variant="body1"
            className={classes.founderBody}
            paragraph={true}
            gutterBottom
          >
            食材が良くなければ美味しい料理はできません。
            又、必要な時必要なだけ小分けして食材をお届けできる物流システムがなければレストランや病院などは困ります。{" "}
          </Typography>
          <Typography
            variant="body1"
            className={classes.founderBody}
            paragraph={true}
            gutterBottom
          >
            私たちは食材流通のプロとして新鮮で美味しく安全な良い食材をお届けする為に、生産者や関係者とのネットワークを活かし、食材の注文を頂いてから納品まで迅速に行うシステムを構築し、お客様から信頼され、働く仲間はみんな謙虚で誠実な心を持ち、良く働きよく学ぶ会社にしましょう。
          </Typography>
          <Typography
            variant="body1"
            className={classes.founderBody}
            paragraph={true}
            align="right"
            gutterBottom
          >
            株式会社 大国フーズ
            <br /> 会長　津田 保弘
          </Typography>
        </div>{" "}
        <img
          src={Founder}
          className={classes.imageFounder}
          alt="Daikoku Founder"
        />
      </Box>
    </Box>
  );
};
const TimeLine = () => {
  const classes = useStyles();
  const dataLength = data.length - 1;

  return (
    <Box className={classes.timeLineBox} color="secondary">
      <Typography color="primary" variant="h2" gutterBottom>
        会社歴史
      </Typography>
      <div className={classes.circle} />
      {data.map((i, index) => {
        return (
          <TimeLineInfo
            key={i.id}
            year={i.year}
            description={i.description}
            classes={classes}
            last={index === dataLength ? true : false}
          />
        );
      })}
    </Box>
  );
};
const TimeLineInfo = ({ year, description, classes, last }) => (
  <>
    <Typography
      className={classes.timeLineText}
      color="primary"
      variant="body1"
    >
      {year}
    </Typography>
    <Typography className={classes.timeLineText} variant="body1" gutterBottom>
      {description}
    </Typography>
    {!last && (
      <>
        <img src={Rectangle} classes={classes.line} alt="rectangle_timeline" />
        <div className={classes.circle} />
      </>
    )}
  </>
);

const InfoBox = () => {
  const classes = useStyles();
  return (
    <Box className={classes.secondaryBox}>
      <Typography color="primary" variant="h2" gutterBottom>
        会長からのメッセージ
      </Typography>
      <InfoTable />
      <Typography color="primary" variant="h2" gutterBottom>
        会長からのメッセージ
      </Typography>
      {/* <img src={Map} alt="location" className={classes.map} /> */}
      <Map />
    </Box>
  );
};

const BackgroundBox = () => {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.thirdBox}>
        {/* <div className={classes.bgBox}>
          <div className={classes.bgBoxCover} />
        </div> */}
        <div className="middleBanner--background" />
        <div className={classes.thirdBox_text}>
          <Typography color="primary" variant="h1" gutterBottom>
            自社農園
          </Typography>
          <Typography
            variant="body1"
            className={classes.thirdBox_p}
            gutterBottom
            paragraph={true}
          >
            平成２１年３月に農業生産法人「株式会社
            大国ファーム」を立ち上げました。
          </Typography>
          <Typography
            variant="body1"
            className={classes.thirdBox_p}
            gutterBottom
            paragraph={true}
          >
            長年の夢でもあり、また将来にむけて弊社が「安心・安全」そして、食べておいしい野菜を育て、その新鮮な野菜をみなさまにお届けしたい、その思いのもとスタッフ一丸となり取り組んでおります。
          </Typography>
          <Typography
            variant="body1"
            className={classes.thirdBox_p}
            gutterBottom
            paragraph={true}
          >
            これからも地元のみなさまの御協力を賜いただきながらスタッフ一同、頑張ってまいります。
            <br />
            乞う御期待くださいませ！
          </Typography>
        </div>
      </Box>
    </>
  );
};
